module.exports = {"653124100":"泽普镇","653124101":"奎依巴格镇","653124200":"波斯喀木乡","653124201":"泽普县依玛乡","653124202":"古勒巴格乡","653124203":"赛力乡","653124204":"依肯苏乡","653124205":"图呼其乡","653124206":"奎依巴格乡","653124207":"阿克塔木乡","653124208":"阿依库勒乡","653124209":"布依鲁克塔吉克族乡","653124210":"桐安乡","653124400":"农场场部","653124401":"泽普县良种场","653124402":"园艺场","653124403":"国营林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653124.json
// module id = 3109
// module chunks = 0